export default "__VITE_ASSET__6c9b740f__"